<script lang="ts">
    import {getInjector} from 'src/core';
    import {Subkind} from 'shared/constants';
    import type {Fond, Rec} from 'src/typings';
    import type {ButtonStyle, ComponentSize} from 'shared/ui-widgets/types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {createEventDispatcher, onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {RecordGridService} from 'src/features/record-grid/services/record-grid.service';
    import RecordService from 'src/features/record/record.service';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpDropdownMenuButton from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuButton.svelte';
    import KpDropdownMenuItem from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuItem.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let rootFondId: number;
    export let buttonLabel: string;
    export let buttonStyle: ButtonStyle = 'success';
    export let buttonSize: ComponentSize = 'md';
    export let isBlock = false;

    const recordGridService = getInjector().getByClass(RecordGridService);
    const recordService = getInjector().getByClass(RecordService);
    const dispatch = createEventDispatcher<{ 'record-created': Rec }>();

    let creatableFonds: Fond[];

    onMount(async () => {
        creatableFonds = await recordGridService.getInsertableFonds({id: rootFondId});
    });

    const handleCreateRecord = async (fond: Fond) => {
        const createdRecord = await recordService.createRecordEditation({
            subkind: fond.ofAuthority ? Subkind.SUBKIND_AUTHORITY : Subkind.SUBKIND_DOCUMENT,
            rootFond: fond,
            fond
        });

        if (!exists(createdRecord)) {
            return;
        }

        dispatch('record-created', createdRecord);
    };
</script>

{#if exists(creatableFonds) && creatableFonds.length > 0}
    {#if creatableFonds.length === 1}
        <KpButton {buttonStyle} {buttonSize} {isBlock} on:click={() => handleCreateRecord(creatableFonds[0])}>
            <IconedContent icon="add">{buttonLabel}</IconedContent>
        </KpButton>
    {:else}
        <KpDropdownMenuButton {buttonStyle} {buttonSize} {isBlock}>
            <svelte:fragment slot="button">
                <IconedContent icon="add" trailingIcon="angle-small-down">{buttonLabel}</IconedContent>
            </svelte:fragment>

            <svelte:fragment slot="menu">
                {#each creatableFonds as fond (fond.id)}
                    <KpDropdownMenuItem on:click={() => handleCreateRecord(fond)}>
                        {pipe(fond, loc())}
                    </KpDropdownMenuItem>
                {/each}
            </svelte:fragment>
        </KpDropdownMenuButton>
    {/if}
{/if}